module.exports = __webpack_public_path__ + "static/media/icon_check.3ec16ad6.svg";